import SortIcon from "@/assets/svg/SortIcon";
import clsx from "clsx";
import React, { forwardRef } from "react";
import styles from "./styles.module.css";

export const NativeSelect = forwardRef<
  HTMLSelectElement,
  React.ComponentProps<"select">
>(function Select({ className, ...props }, ref) {
  return (
    <div className={styles.wrapper}>
      <select
        className={clsx(className, styles.trigger)}
        {...props}
        ref={ref}
      />
      <label htmlFor="">
        <SortIcon className={styles.indicator} />
      </label>
    </div>
  );
});
